import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DASHBOARD_DATE_RANGE_MESSAGE } from '@shared/index';
import { DateRangeOption } from '@core/models/api-response.model';
import { formatDate } from 'date-fns';
import { CommonFunctions } from '@shared/common-functions';

@Component({
  selector: 'app-metric-display',
  templateUrl: './metric-display.component.html',
  styleUrls: ['../common-dashboard/common-dashboard.component.scss']
})
export class MetricDisplayComponent implements OnInit{
  @Output() parkingLotByStatesOnChange = new EventEmitter<{event:any, reset:boolean}>();
  @Output() startDateChanges = new EventEmitter<void>();
  @Output() endDateChanges = new EventEmitter<void>();
  @Output() searchChanges = new EventEmitter<{ startDateBoard: any; endDateBoard: any}>();
  @Output() dateRangeData = new EventEmitter<{value: any}>();
  @Input() same: boolean = false;
  @Input() checkstartDate;
  @Input() checkendDate;
  @Input() parkingLotByStates: any;
  @Input() selectedParkingLot;
  @Input() start;
  @Input() end;
  @Input() parkerCount: number = 0;
  @Input() groupBookingCount: number = 0;
  dateRangeValue: number;
  minEndDate: Date;
  dateRangeMessage : string = DASHBOARD_DATE_RANGE_MESSAGE;
  dateRangeOption: DateRangeOption[] = [
    { name: 'Custom', value: 1  },
    { name: 'Last Month', value: 30 },
    { name: 'Last 3 Months', value: 90 },
    { name: 'Last 6 Months', value: 180 },
    { name: 'Last 13 Months', value: CommonFunctions.getDaysForMonths(13) },
  ];

  ngOnInit(): void {
    this.dateRangeValue = this.dateRangeOption[0].value;
    this.onStartDateChange();
  }

  parkingLotByStatesFunc(event,reset:boolean){
    this.parkingLotByStatesOnChange.emit({event,reset});
  }

  formatDateToString(date: Date): string {
    return formatDate(date, 'MMM dd, yyyy');
  }

  dateRangeChange(event, reset) {
    this.dateRangeValue = event.value;
    this.dateRangeData.emit({ value: event.value });
    const selectedOption = this.dateRangeOption.find(option => option.value === event.value);
    if (!selectedOption) return;
    const today = new Date();
    let startDate: Date;
    let endDate: Date;

    const getMonthStartDate = (monthsAgo: number) => {
      return new Date(today.getFullYear(), today.getMonth() - monthsAgo, 1);
    };
    const getMonthEndDate = (monthsAgo: number) => {
      const year = today.getFullYear();
      const month = today.getMonth() - monthsAgo + 1;
      return new Date(year, month, 0);
    };

    switch (selectedOption.value) {
      case 1:
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        endDate = new Date(today);
        break;

      case 30:
        startDate = getMonthStartDate(1);
        endDate = getMonthEndDate(1);
        break;

      case 90:
        startDate = getMonthStartDate(3);
        endDate = getMonthEndDate(1);
        break;

      case 180:
        startDate = getMonthStartDate(6);
        endDate = getMonthEndDate(1);
        break;

      case CommonFunctions.getDaysForMonths(13):
        startDate = getMonthStartDate(13);
        endDate = getMonthEndDate(1);
        break;

      default:
        return;
    }
    this.start = this.formatDateToString(startDate);
    this.end = this.formatDateToString(endDate);
    this.minEndDate = startDate;
    if (reset) {
      this.searchFunc(this.start, this.end);
    }
}

  searchFunc(start, end) {
    this.searchChanges.emit({ startDateBoard: start, endDateBoard: end });
  }


  resetfilter(reset: boolean) {
    this.dateRangeValue = this.dateRangeOption[0].value;
    this.selectedParkingLot = this.parkingLotByStates[0].id
    this.parkingLotByStatesFunc({ value: this.selectedParkingLot }, reset);
    this.dateRangeChange({ value: this.dateRangeValue }, reset);
}

onStartDateChange() {
  if (this.start) {
    const startDate = new Date(this.start);
    this.minEndDate = new Date(startDate);
  }
}
}
